<template>
  <div class="row mt-3">
    <div class="col-md-12">
      <div class="icon-toggle">
        <div
          class="dot cursor-pointer green"
          @click="extraExpanded = !extraExpanded"
        >
          <em class="title-icon" :class="getIcon(extraExpanded)" />
        </div>
        <span class="dot-title">Información del PEI</span>
      </div>
    </div>
    <div v-if="extraExpanded" class="col-md-12 mt-2">
      <div class="box-container">
        <div
          v-for="(item, index) in value"
          :key="'pei-info' + index"
          class="row p-3"
        >
          <div class="col-2">
            <custom-balloon
              :background-color="'green'"
              class="mt-1"
              :text="item.statusName"
            />
          </div>
          <div class="col pl-5">
            <div class="color-gray-6 font-14 font-weight-normal">Fecha:</div>
            <div class="font-weight-normal text-black">
              {{ item.date | date }}
            </div>
          </div>
          <div class="col">
            <div class="color-gray-6 font-14 font-weight-normal">
              Número de PEI:
            </div>
            <div class="font-weight-normal text-black">
              {{ item.peiNumber }}
            </div>
          </div>
          <div class="col text-right">
            <action-button
              class="mr-n3"
              i="fas fa-file-search"
              text="Ver Documentos"
              variant="outline-success transparent-color bg-transparent"
              @click="viewDocument(item)"
            />
          </div>
          <div
            v-if="index != value.length - 1"
            class="col-12 separator-line-2 mt-4"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomBalloon from 'custom-balloon';
import ActionButton from 'ActionButton';

export default {
  name: 'StudentPeiInfo',
  components: {
    CustomBalloon,
    ActionButton,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      extraExpanded: false,
    };
  },
  methods: {
    getIcon(expanded) {
      return expanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right';
    },
    async viewDocument() {
      return null;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';

.icon-toggle {
  display: flex;
  align-items: center;
  border-radius: 32px;
  padding: 5px;
  display: inline-block;
  background: map-get($colors, 'gray-9');
  padding-left: 5px;
  padding-right: 20px;

  .dot-title {
    font: Bold 18px/22px Lato;
    letter-spacing: 0px;
    color: map-get($colors, 'black');
  }

  .title-icon {
    color: map-get($colors, 'white');
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 7px;
  }
}

.dot-title {
  font: Bold 18px/22px Lato;
  letter-spacing: 0px;
  color: map-get($colors, 'black');
}

.dot {
  box-shadow: 0px 3px 6px map-get($colors, 'black-transparency-41');
  margin: 2px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border-style: solid;
  border-width: 3px;
  border-color: map-get($colors, 'white');
  display: inline-block;
  margin-right: 15px;
}

.dot.green {
  background-color: map-get($colors, 'green');
}
.dot.gray {
  background-color: map-get($colors, 'gray-7');
}
.box-container {
  background: map-get($colors, 'secondary-3');
  padding: 10px;
  border-radius: 5px;

  &__row {
    margin: 8px 5px;
  }
}

.transparent-color:hover {
  color: map-get($colors, 'green') !important;
}

.separator-line-2 {
  border-bottom: 1px solid map-get($colors, 'gray-5');
}
</style>
